import React, { Component } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import { USER } from "../../constants/constant";

class PhleboPerformance extends Component {
	constructor(props) {
		super(props);
		this.state = {
			userdata: USER.access_token,
			loading: true, // Loader
		};
	}

	handleLoad = () => {
		this.setState({ loading: false });
	};

	render() {
		return (
			<>
				{this.state.loading && (
					<div
						style={{
							position: "fixed",
							top: 0,
							left: 0,
							right: 0,
							bottom: 0,
							backgroundColor: "#fff",
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
							zIndex: 1000,
						}}
					>
						<div
							style={{
								display: "flex",
								flexDirection: "column", // Stack vertically
								alignItems: "center", // Center horizontally
								justifyContent: "center",
							}}
						>
							<div
								className="spinner-border text-primary"
								role="status"
								style={{ marginBottom: "10px" }} // Space between icon and text
							></div>
							<div
								style={{
									fontSize: "16px",
									color: "#007bff",
								}}
							>
								Loading...
							</div>
						</div>
					</div>
				)}

				<div style={{ height: "100%", width: "100%", display: "flex" }}>
					<iframe
						src={
							"https://phlebo-performance.medibuddy.in/performance?Token=" +
							this.state.userdata
						}
						style={{ width: "100%", border: "none" }}
						title="Phlebo Performance"
						onLoad={this.handleLoad}
					></iframe>
				</div>
				<Container>
					<Row>
						<div className="fixed-bottom p-l-15 p-r-15 p-t-5 p-b-5">
							<div className="p-b-10">
								<button
									type="button"
									className="btn btn-outline-primary width-100 border-curve-10"
									onClick={this.props.history.goBack}
								>
									Back
								</button>
							</div>
						</div>
					</Row>
				</Container>
			</>
		);
	}
}
export default PhleboPerformance;
